<app-iota-modal [modalOptions]="modalOptions" (close$)="closeDialog()">
    <span modal-header class="text-lg font-bold" i18n>Edit employee - leaving</span>

    <div modal-body class="p-5 flex flex-col items-stretch gap-3">
        <app-employee-leaving-dialog-validation-data
            [leavingRequest]="selectedLeavingRequest()"
            [employee]="data.employee"
            [officeIdToNameMap]="officeIdToNameMap$ | ngrxPush"
        >
        </app-employee-leaving-dialog-validation-data>

        <div class="divider"></div>

        <div class="w-full grid grid-cols-4 gap-y-2 gap-x-5 items-center" [formGroup]="form">
            <label class="col-span-2 label" for="companyLeavingDate" i18n>Leaving date</label>
            <div class="col-span-2 flex flex-col gap-1">
                <input class="input input-bordered" formControlName="companyLeavingDate" type="date" />
                <div
                    class="flex flex-col items-start text-error text-xs"
                    *ngIf="form.get('companyLeavingDate')?.dirty && form.get('companyLeavingDate')?.invalid"
                >
                    <strong *ngIf="form.get('companyLeavingDate')?.hasError('companyLeavingDate')" i18n>
                        The field "Leaving date" is mandatory.
                    </strong>
                </div>
            </div>

            <!-- Show the calculated license end date-->
            <label class="col-span-2 label justify-start items-center gap-2">
                <ng-container i18n>chæmp license will end on</ng-container>
                <iota-icon
                    icon="information-circle"
                    class="tooltip"
                    data-tip="This is the earliest possible date when the chæmp license can be deactivated considering all product run times. This also means the user account will be deactivated at this time."
                    i18n-data-tip
                ></iota-icon>
            </label>
            <ng-container>
                <span *ngIf="licenseEndDateCalculationLoading$ | ngrxPush" class="col-span-2 btn btn-sm btn-ghost loading"></span>
                <input
                    *ngIf="!(licenseEndDateCalculationLoading$ | ngrxPush)"
                    class="col-span-2 input input-bordered"
                    [value]="calculatedLicenseEndDate$ | ngrxPush"
                    type="date"
                    disabled
                />
            </ng-container>

            <div class="col-span-4 alert alert-warning shadow-lg my-2" *ngIf="isScheduledAndCannotBeModified">
                <div>
                    <iota-icon icon="exclamation-triangle" size="1.5"></iota-icon>
                    <span class="w-full text-sm" i18n>The deadline has been reached, the leaving request cannot be modified anymore.</span>
                </div>
            </div>
            <div class="col-span-4 alert alert-error shadow-lg my-2" *ngIf="actionError$ | ngrxPush">
                <div>
                    <iota-icon icon="exclamation-triangle" size="1.5"></iota-icon>
                    <span class="w-full text-sm" i18n>There was an error while saving the data. Please contact our support.</span>
                </div>
            </div>
        </div>
    </div>

    <div modal-footer class="flex grow gap-2">
        <button class="btn btn-sm btn-ghost rounded-full" (click)="closeDialog()" i18n>Cancel</button>
        <div class="flex-1"></div>
        <button
            class="btn btn-outline btn-sm rounded-full flex flex-row items-center gap-2"
            *ngIf="showCancelButton"
            [disabled]="isCancelButtonDisabled"
            [ngClass]="{ loading: cancelLeavingPressed && (actionLoading$ | ngrxPush) }"
            (click)="cancelLeaving()"
            i18n
        >
            Cancel leaving
        </button>
        <button
            class="btn btn-primary btn-sm rounded-full flex flex-row items-center gap-2"
            *ngIf="showSaveButton"
            [disabled]="isSaveButtonDisabled"
            [ngClass]="{ loading: savePressed && (actionLoading$ | ngrxPush) }"
            (click)="save()"
            i18n
        >
            Save
        </button>
    </div>
</app-iota-modal>
